import React from "react"
import { ChatRoom } from "../../../../rpcs/dist/ChatRoomRPC"
import { EDIT_TYPE } from "../../types"
import { AddButton } from "./components/add-button"
import { EditContentContext } from "./components/editer-content"
import { container, IContainerProps } from "./container"

const canSurvey = (chatRoom: ChatRoom): boolean => {
  if (!chatRoom.channel) {
    return false
  }
  return chatRoom.channel.billingStatus.plan.survey
}

const ChatEditorComponent = ({
  contents,
  chatRoom,
  actions,
}: IContainerProps) => {
  return (
    <>
      {contents &&
        contents.map((content, i) => (
          <React.Fragment key={content.uuid}>
            <EditContentContext
              index={i}
              content={content}
              prevContent={i > 0 ? contents[i - 1] : null}
              isLast={i + 1 === contents.length}
              actions={actions}
            />
            {content._editMetaData.type === EDIT_TYPE.MENU && (
              <AddButton
                content={content}
                contents={contents}
                actions={actions}
                options={{
                  survey: canSurvey(chatRoom),
                }}
              />
            )}
          </React.Fragment>
        ))}
    </>
  )
}

export const ChatEditor = container(ChatEditorComponent)
